var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('MstSelectBox',{attrs:{"options":_vm.categoryOptions,"disabled":_vm.readOnly},on:{"change":_vm.selectHandler},model:{value:(_vm.categoryValue),callback:function ($$v) {_vm.categoryValue=$$v},expression:"categoryValue"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }